import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Spinner from '../common/Spinner';

const VehicleList = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/owner/vehicles')
      .then(res => setVehicles(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="glass-card fade-in">
      <h2>My Vehicles</h2>
      <div className="vehicle-grid">
        {vehicles.map(v => (
          <div key={v.id} className="vehicle-card">
            <h3>{v.plate_number}</h3>
            <p>{v.model}</p>
            <p>Capacity: {v.capacity}</p>
            <p>Route: {v.route_description}</p>
          </div>
        ))}
      </div>
      <style>{`
        .vehicle-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 1rem;
          margin-top: 1rem;
        }
        .vehicle-card {
          background: white;
          padding: 1rem;
          border-radius: var(--radius-md);
          box-shadow: var(--shadow-sm);
        }
        .vehicle-card h3 {
          color: var(--primary);
          margin-bottom: 0.5rem;
        }
      `}</style>
    </div>
  );
};
export default VehicleList;